module.exports = __webpack_public_path__ + "static/media/28.610797c8.jpg";